import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

export interface WarningBoxProps {
  title?: ReactNode;
  description?: ReactNode;
  className?: string;
}

export const WarningBox: FC<WarningBoxProps> = (props) => (
  <div
    className={classNames(
      'flex flex-row gap-1 xl:w-1/2 mx-auto p-4 rounded bg-orange-400 text-white',
      props.className,
    )}
  >
    <Icon glyph='fa-exclamation-triangle' size='lg' className='-mt-1' />
    <div>
      {props.title !== undefined && <h4 className='mt-0'>{props.title}</h4>}
      {props.description !== undefined && <div>{props.description}</div>}
    </div>
  </div>
);
